import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const denyReturn = {
  name: "denyReturn" as const,
  input: z.object({
    returnId: zExt.objectId(),
    customerNotes: z.string().optional(),
  }),
  output: z.null(),
};
